import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Main = () => import('../views/main/main.vue')
const Homepage = () => import('../views/homepage.vue')
const Calligraphy = () => import('../views/product/calligraphy.vue')
const Art = () => import('../views/product/art.vue')
const Service = () => import('../views/service.vue')
const Case = () => import('../views/case.vue')
const About = () => import('../views/about.vue')

const routes = [{
  path: '/', component: Main, redirect: '/homepage', children: [
    {path: 'homepage', name: 'homepage', component: Homepage},
    {path: 'product/calligraphy', name: 'calligraphy', component: Calligraphy},
    {path: 'product/art', name: 'art', component: Art},
    {path: 'service', name: 'service', component: Service},
    {path: 'case', name: 'case', component: Case},
    {path: 'about', name: 'about', component: About},
  ]
}]

/**
 * 修改路由重复点击报错
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  routes
})

/*路由守卫*/
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js